/* @flow */
import {type Store} from '../../reducers/index';
import cookieUtils from '../../utils/cookieUtils';
import {LOCATION_COOKIE} from '../../utils/locationData';
import {makeUpdatedSERPUrl} from '../../utils/routerUtils';

type Action = {
    type: string,
    // TODO Add flow type to `payload` when redux-little-router upgraded to ^15.1.0
    payload: any
};

export default function setLocationData(store: Store, {payload}: Action) {
    const state = store.getState();
    if (payload.results) {
        const lbsKeywords = payload.results.searchTerm
            ? payload.results.searchTerm.description
            : null;
        const params = {
            ...payload.variables.params,
            ...payload.variables.request,
            q: lbsKeywords
        };

        const haStatePersistCookie = cookieUtils.readCookie(LOCATION_COOKIE);

        if (lbsKeywords) {
            haStatePersistCookie.lbsKeywords = lbsKeywords;
        }

        haStatePersistCookie.lastSearchUrl = makeUpdatedSERPUrl(
            params,
            ['include'],
            state,
            {
                canonicalizeKeywords: false
            }
        );
        cookieUtils.writeCookie(LOCATION_COOKIE, haStatePersistCookie);
    }
}
